/* eslint-disable @typescript-eslint/no-explicit-any */
import { ALL_SELECT_VALUE_STRING } from '../../../utils/constants/global-constants'
import { mpfRViewsHttp } from '../api/mpf-views-http'
import { formatStringForServer } from '../formatting/formatting'
import { and } from './data'

interface UserProfileView {
  AssignedComponentCode: number
  DoDNumber: string
  DutyEmail: string
  DutyPhone: string
  Installation: string
  ItemModified?: any //Person_Single
  OrgMAJCOM: string
  Organization: string
  PASCODE: string
  PASCODEServicedBy: string
  PascodeID: string
  ProfileStatus: string
  Rank: string
  ServicingMAJCOM: string
  ServicingOrganization: string
  UserDisplayName: string
  UserRID: string
  eKey: string
  eTag: string
}

interface UserProfileViewArgs {
  isListModified?: boolean
  onePageOnly?: boolean
  pageNumber?: number
  searchFilter?: string
  userRID?: string
}
interface ProfileCount {
  ID_count: number
}

const COLUMN_NAMES = {
  AssignedComponentCode: 'AssignedComponentCode',
  AssignedComponentValue: 'AssignedComponentValue',
  DoDNumber: 'DoDNumber',
  DutyEmail: 'DutyEmail',
  DutyPhone: 'DutyPhone',
  EKey: 'eKey',
  ETag: 'eTag',
  ID: 'ID',
  Installation: 'Installation',
  OrgMAJCOM: 'OrgMAJCOM',
  Organization: 'Organization',
  PASCODE: 'PASCODE',
  PascodeID: 'PascodeID',
  ProfileStatus: 'ProfileStatus',
  Rank: 'Rank',
  ServicingBy: 'ServicingBy',
  ServicingCSSPASCODE: 'ServicingCSSPASCODE',
  ServicingMAJCOM: 'ServicingMAJCOM',
  ServicingOrganization: 'ServicingOrganization',
  UserDisplayName: 'UserDisplayName',
  UserRID: 'UserRID',
}
const constructInquiryFilter = (args: UserProfileViewArgs): string => {
  const filters: string[] = []
  if (args?.searchFilter && args.searchFilter !== ALL_SELECT_VALUE_STRING) {
    filters.push(
      `(contains(DoDNumber, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(Installation, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(Organization, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(PASCODE, '${formatStringForServer(
        args.searchFilter,
        'single-quotes'
      )}') or contains(DutyEmail, '${formatStringForServer(args.searchFilter, 'single-quotes')}'))`
    )
  }
  if (args?.userRID) {
    filters.push(`UserRID eq '${args.userRID}'`)
  }
  const filter = and(...filters)
  return filter
}

const getProfileViewCount = async (args: UserProfileViewArgs): Promise<ProfileCount[]> => {
  const list = await mpfRViewsHttp().getview(LIST_NAME)
  const filter = constructInquiryFilter(args)
  const items = await list
    .query()
    .filter(filter)
    .select(COLUMN_NAMES.ID)
     .count(COLUMN_NAMES.ID) 
    .get()
  return [...items] as ProfileCount[]
}

const getUserProfileView = async (args: UserProfileViewArgs): Promise<UserProfileView[]> => {
  try {
    const pageNum = args?.pageNumber ?? -1
    const PAGE_SIZE = 100
    const onePageOnly = args?.onePageOnly ?? false
    const list = await mpfRViewsHttp().getview(LIST_NAME)
    const filter = constructInquiryFilter(args)
    const query = await list
      .query()
      .filter(filter)
      .select(...Object.values(COLUMN_NAMES))
      .orderBy([{ ascending: false, orderBy: 'UserDisplayName' }])

    const startAtPageQuery = pageNum > -1 ? query.skip(pageNum * PAGE_SIZE) : query

    const oneOrManyPagesQuery = onePageOnly ? startAtPageQuery.top(PAGE_SIZE) : startAtPageQuery

    const items: any = await oneOrManyPagesQuery.get()

    return [...items.sort((a, b) => b.ItemModified - a.ItemModified)] as UserProfileView[]
  } catch (error) {
    console.error(error)
    return [] as UserProfileView[]
  }
}

const LIST_NAME = 'V_UserProfile'
export {
  COLUMN_NAMES,
  LIST_NAME,
  type ProfileCount,
  type UserProfileView,
  type UserProfileViewArgs,
  getProfileViewCount,
  getUserProfileView
}
